module.exports = __webpack_public_path__ + "static/media/diamondCertificateImage2.3fe69195.jpg";